import React from 'react';
import { cx } from '../../../../../ui/components/cx';

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  tone?: 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
  className?: string;
}

/** Small label + number tile for page-level counts. */
const StatTile: React.FC<StatTileProps> = ({ label, value, tone = 'neutral', className }) => (
  <div className={cx('tp-stat', `tp-stat--${tone}`, className)}>
    <span className="tp-stat__label">{label}</span>
    <span className="tp-stat__value">{value}</span>
  </div>
);

export default StatTile;
